import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ClientService } from '../services/client.service';
import { AuthService } from '../services/auth.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { APIUrl } from '../constant/api-call';
import { PERMISSION } from '../constant/permission';
import { PrimeNgModule } from '../shared/prime-ng.module';
import { CommonModule } from '@angular/common';
import { ProjectService } from '../services/project.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, PrimeNgModule, RouterModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;

  public loginForm: FormGroup;
  public commonDataObject = {
    APIObj: APIUrl,
    issuccessAlert: false,
    iserrorAlert: false,
    apiMeassge: '',
    isLoad: true,
    isForgot: false,
    isOTP: false,
    isVerify: false,
    isMatch: false
  }

  public currentSlideIndex = 0;
  public slideInterval: any;
  public showPassword = false;
  public showNewPassword = false;
  public showConfirmPassword = false;
  public isLoading = false;

  public slides = [
    {
      title: 'Jeevan Sanidhya',
      description: 'Jivan Sanidhya by SRK Knowledge Foundation explores great leaders\' lives through their autobiographies, offering timeless wisdom on truth, non-violence, and values-based living—reflecting SRK Group\'s commitment to "Pure Knowledge" and ethical leadership.',
      icon: 'fas fa-book-open',
      tags: ['Geeta Saar', 'Spiritual Leadership', 'Life Values'],
      backgroundImage: 'linear-gradient(135deg, #0f3a7d, #1e5a96)'
    },
    {
      title: 'Geeta Rath',
      description: 'Gita Gyaan Rath is a mobile spiritual library by SRK Knowledge Foundation. A chariot of wisdom carrying books, it travels to communities, schools, and spiritual fairs—bringing the light of the Gita to everyone it meets. 🚛📚✨',
      icon: 'fas fa-chalkboard-user',
      tags: ['Spiritual Wisdom', 'Literary', 'Inspiration'],
      backgroundImage: 'linear-gradient(135deg, #1565c0, #0288d1)'
    },
    {
      title: 'Laljidada no Vadlo',
      description: '"Laljidada no Vadlo" is a free healthcare facility set up in 2014 by SRK Group at Lathi village, named after the founder\'s late father. It has impacted over 1.1 million lives by making medical care accessible to the underprivileged.',
      icon: 'fas fa-home',
      tags: ['Free Healthcare', 'Community Service', 'Medical Accessibility'],
      backgroundImage: 'linear-gradient(135deg, #0d47a1, #1976d2)'
    },
    {
      title: 'Nanduba Medical Center',
      description: 'Nanduba Medical Center by SRK Knowledge Foundation provides affordable healthcare services, including consultations with over 50 medical professionals at highly subsidized rates. The center offers OPD, physiotherapy, pathology lab, digital X-ray, USG, HIV/AIDS control, dentistry, and ambulance services, with specialist and super-specialist visits once a week free of cost.',
      icon: 'fas fa-hospital-user',
      tags: ['Healthcare', 'Emergency', 'Free Camps'],
      backgroundImage: 'linear-gradient(135deg, #1e3c72, #2a5298)'
    },
    {
      title: 'Relief Center',
      description: 'Relief Center (1997) by SRK Group, inspired by Indravadanbhai, provides daily personal guidance from Govind Dholakia to 100+ needy people. It has aided 48,000 with medical financial support and awarded 11,000+ scholarships for higher education and studies abroad.',
      icon: 'fas fa-hand-holding-heart',
      tags: ['Social Assistance', 'Community Welfare', 'Educational Scholarships'],
      backgroundImage: 'linear-gradient(135deg, #00838f, #00bcd4)'
    },
    // {
    //   title: 'SRKAY EXP',
    //   description: 'Special initiative for community development and empowerment through various programs and outreach activities.',
    //   icon: 'fas fa-star-of-life',
    //   tags: ['Community', 'Development', 'Outreach'],
    //   backgroundImage: 'linear-gradient(135deg, #0c3483, #1565c0)'
    // }
  ];

  constructor(
    private fb: FormBuilder,
    private clientService: ClientService,
    private authService: AuthService,
    public projectService: ProjectService,
    private router: Router) {
    this.loginForm = this.fb.group({
      user_login_name: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      confirm_password: [''],
      otp: [null]
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.commonDataObject.isLoad = false;
    }, 1000);
    let uCode = sessionStorage.getItem('user_code');
    if (uCode !== null) {
      this.projectService.getMasterData();
      this.router.navigate(['/project_dashboard']);
    }
    this.startSlideshow();
  }

  ngOnDestroy(): void {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  }

  startSlideshow(): void {
    this.slideInterval = setInterval(() => {
      this.nextSlide();
    }, 6000);
  }

  nextSlide(): void {
    this.currentSlideIndex = (this.currentSlideIndex + 1) % this.slides.length;
  }

  previousSlide(): void {
    this.currentSlideIndex = (this.currentSlideIndex - 1 + this.slides.length) % this.slides.length;
  }

  changeSlide(direction: number): void {
    if (direction === 1) {
      this.nextSlide();
    } else {
      this.previousSlide();
    }
    this.resetInterval();
  }

  currentSlide(index: number): void {
    this.currentSlideIndex = index;
    this.resetInterval();
  }

  resetInterval(): void {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
      this.startSlideshow();
    }
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  onSubmit(): void {
    this.commonDataObject.isLoad = true;
    this.isLoading = true;
    const loginData = this.loginForm.value;
    let payload = {
      "email_address": loginData?.user_login_name,
      "password": loginData?.password
    }
    this.authService.signIn(payload).subscribe({
      next: (res) => {
        if (res && res.code === "CSR_MS_OK_200") {
          sessionStorage.setItem('token', res.data[0].token);
          sessionStorage.setItem('user_code', res.data[0].user_code);
          sessionStorage.setItem('user_category_code', res.data[0].user_category_key);
          sessionStorage.setItem('first_name', res.data[0].first_name);
          sessionStorage.setItem('email_address', res.data[0].email_address);
          sessionStorage.setItem('page_permission', res.data[0].page_permission);
          sessionStorage.setItem('project_list', res.data[0].project_id);
          sessionStorage.setItem('user_category_id', res.data[0].user_category_id);

          this.commonDataObject.apiMeassge = res.message;
          this.commonDataObject.issuccessAlert = true;
          this.loginForm.reset();
          setTimeout(() => {
            this.commonDataObject.isLoad = false;
            this.isLoading = false;
            const userRole = sessionStorage.getItem('user_category_code');
            if(userRole !== 'USER') {
              this.router.navigate(['/project_dashboard']);
            } else {
              this.router.navigate(['/form_submission']);
            }
          }, 1000);
        } 
        else {
          this.commonDataObject.apiMeassge = res.body?.message;
          this.commonDataObject.iserrorAlert = true;
          this.isLoading = false;
        }
        setTimeout(() => {
          this.commonDataObject.isLoad = false;
          this.commonDataObject.issuccessAlert = false;
          this.commonDataObject.iserrorAlert = false;
        }, 1000);
      },
      error: (error) => {
        this.commonDataObject.iserrorAlert = true;
        this.commonDataObject.apiMeassge = error.error?.message
        this.isLoading = false;
        setTimeout(() => {
          this.commonDataObject.isLoad = false;
          this.commonDataObject.issuccessAlert = false;
          this.commonDataObject.iserrorAlert = false;
        }, 1000);
      }
    });
  }

  backToLogin() {
    this.commonDataObject.isOTP = false;
    this.commonDataObject.isVerify = false;
    this.commonDataObject.isForgot = false;
    this.loginForm.get('otp')?.reset();
    this.loginForm.get('password')?.reset();
    this.loginForm.get('confirm_password')?.reset();
  }

  forgotPW() {
    if(this.isLoading){
      return;
    }
    this.commonDataObject.isLoad = true;
    this.commonDataObject.isForgot = true;
    this.commonDataObject.isOTP = false;
    this.commonDataObject.isVerify = false;
    setTimeout(() => {
      this.commonDataObject.isLoad = false;
    }, 1000);
  }

  sendOTP(arg?: any) {
    this.commonDataObject.isLoad = true;
    this.commonDataObject.isForgot = true;
    this.commonDataObject.isVerify = false;
    this.commonDataObject.isOTP = false;
    let payload: any = {
      "email_address": this.loginForm.get('user_login_name')?.value,
      "password": arg == 'password' && this.loginForm.get('confirm_password')?.value ? this.loginForm.get('confirm_password')?.value : null,
      "is_otp_verify": arg == 'verify' ? true : false,
      "otp": arg == 'verify' ? this.loginForm.get('otp')?.value : null
    }
    this.clientService.postAPI(this.commonDataObject.APIObj.FORGET_PASSWORD, payload).subscribe({
      next: (res: any) => {
        if (res && (res.code === "CSR_MS_OK_MAIL_SENT_SUCCESS_200" || res.code === "CSR_MS_OK_200")) {
          this.commonDataObject.isOTP = true;
          this.commonDataObject.isForgot = false;
          this.commonDataObject.issuccessAlert = true;
          if (arg == 'verify') {
            this.commonDataObject.isVerify = true;
            this.commonDataObject.isOTP = false;
          }
          this.commonDataObject.apiMeassge = res.message;
          this.loginForm.get('password')?.reset();
          if (arg == 'password') {
            this.backToLogin();
          }
          setTimeout(() => {
            this.commonDataObject.isLoad = false;
            this.commonDataObject.issuccessAlert = false;
          }, 1000);
        }
        else {
          this.commonDataObject.apiMeassge = res.message;
          this.commonDataObject.iserrorAlert = true;
        }
        setTimeout(() => {
        this.commonDataObject.isLoad = false;
          this.commonDataObject.iserrorAlert = false;
        }, 1000);
      },
      error: (error) => {
        this.commonDataObject.iserrorAlert = true;
        this.commonDataObject.apiMeassge = error.error.message;
        setTimeout(() => {
          this.commonDataObject.iserrorAlert = false;
          this.commonDataObject.isLoad = false;
        }, 1000);
      }
    });
  }

  onOtpChange(otp: any) {
    this.loginForm.get('otp')?.setValue(otp);
  }

  checkPassword() {
    this.commonDataObject.isMatch = this.loginForm.get('confirm_password')?.value === this.loginForm.get('password')?.value;
  }

}